import { render, staticRenderFns } from "./metakognicia.vue?vue&type=template&id=ac2dacae&scoped=true&"
import script from "./metakognicia.vue?vue&type=script&lang=js&"
export * from "./metakognicia.vue?vue&type=script&lang=js&"
import style0 from "./metakognicia.vue?vue&type=style&index=0&id=ac2dacae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2dacae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
